var ServiceNetworkEnum = /* @__PURE__ */ ((ServiceNetworkEnum2) => {
  ServiceNetworkEnum2["SERVICE_NETWORK_TITLE"] = "service-network--title";
  ServiceNetworkEnum2["SERVICE_NETWORK_BREADCRUMB"] = "service-network--breadcrumb";
  ServiceNetworkEnum2["SERVICE_NETWORK_LIST"] = "service-network--list";
  ServiceNetworkEnum2["MAIN_SERVICE_NETWORK_LIST"] = "service-network--main-service-network-list";
  ServiceNetworkEnum2["VER_MAIS_BUTTON"] = "service-network--ver-mais-button";
  return ServiceNetworkEnum2;
})(ServiceNetworkEnum || {});
export {
  ServiceNetworkEnum
};
